export default "__VITE_ASSET__BWumyhqm__"